/* App.svelte generated by Svelte v3.23.1 */
import {
	SvelteComponent,
	add_render_callback,
	append,
	attr,
	destroy_block,
	detach,
	element,
	empty,
	globals,
	init,
	insert,
	is_function,
	listen,
	noop,
	run_all,
	safe_not_equal,
	set_data,
	set_input_value,
	space,
	text,
	update_keyed_each
} from "svelte/internal";

const { document: document_1 } = globals;
import { gun, SEA, peers } from "./beforeload.js";

function add_css() {
	var style = element("style");
	style.id = "svelte-4dba2k-style";
	style.textContent = "#pollMain.svelte-4dba2k.svelte-4dba2k{position:absolute;top:50%;left:50%;transform:translate(-50%, -50%);font-family:\"Quicksand\";max-width:90vw}#pollName.svelte-4dba2k.svelte-4dba2k{font-size:clamp(25px, 8vw, 60px);font-family:inherit;border:none;outline:none;max-width:100%;padding:0 0;font-weight:600;background:none;color:inherit}#pollDesc.svelte-4dba2k.svelte-4dba2k{margin:15px 0;outline:none;border:none;font-family:inherit;max-width:100%;font-size:clamp(10px, 5vw, 30px)}#pollOpts.svelte-4dba2k.svelte-4dba2k{display:flex;flex-direction:column}.pollOpt.svelte-4dba2k.svelte-4dba2k{min-width:100px;width:auto;background-color:var(--theme-color);height:clamp(40px, 10vw, 70px);margin-bottom:20px;border-radius:30px;outline:none;cursor:pointer;display:flex;align-items:center}.optTxt.svelte-4dba2k.svelte-4dba2k{padding:0 20px;height:70px;line-height:70px;top:50%;font-size:clamp(10px, 5vw, 20px);display:inline-block;width:clamp(10px, 95vw, 500px);min-width:0;flex-grow:1;text-overflow:ellipsis;color:var(--dark-bg);line-break:strict}.optRemove.svelte-4dba2k.svelte-4dba2k{padding-right:20px;height:100%;display:flex;align-items:center;color:var(--dark-bg)}[placeholder].svelte-4dba2k.svelte-4dba2k:empty::before{content:attr(placeholder);color:#555}input.optTxt.svelte-4dba2k.svelte-4dba2k{font-family:inherit;background:none;border:none;outline:none}.optTxt.svelte-4dba2k.svelte-4dba2k:placeholder{color:rgba(0, 0, 0, 0.699)}#pollOptCreate.svelte-4dba2k.svelte-4dba2k{width:14px;padding:20px;border-radius:50%;height:14px;text-align:center;background-color:var(--theme-color);margin:0 auto;display:flex;cursor:pointer;float:left}#pollSubmit.svelte-4dba2k.svelte-4dba2k{width:auto;padding:20px;border-radius:30px;height:auto;text-align:center;background-color:var(--theme-color);margin:0 auto;display:flex;cursor:pointer;float:right;color:var(--dark-bg);font-weight:600}#pollOptCreate.svelte-4dba2k i.svelte-4dba2k{position:relative;vertical-align:middle;color:var(--dark-bg)}.optSelect.svelte-4dba2k.svelte-4dba2k{cursor:pointer}#voteCount.svelte-4dba2k.svelte-4dba2k{margin-top:0px;margin-bottom:20px;display:inline-block;vertical-align:middle}#deliveredVote.svelte-4dba2k.svelte-4dba2k{text-align:right;float:right;font-size:clamp(5px, 4vw, 15px)}.optPercentage.svelte-4dba2k.svelte-4dba2k{color:var(--dark-bg);padding-right:20px}@keyframes svelte-4dba2k-rotate{from{-webkit-transform:rotate(0deg)}to{-webkit-transform:rotate(360deg)}}.loading.svelte-4dba2k.svelte-4dba2k{-webkit-animation-name:svelte-4dba2k-rotate;-webkit-animation-duration:3s;-webkit-animation-iteration-count:infinite;-webkit-transition-timing-function:linear;animation-name:svelte-4dba2k-rotate;animation-duration:3s;animation-iteration-count:infinite;transition-timing-function:linear}.pollOpt.svelte-4dba2k.svelte-4dba2k:hover{width:100% !important}.winningPercentage.svelte-4dba2k.svelte-4dba2k{font-weight:700;font-size:25px}#pollSubmit.svelte-4dba2k.svelte-4dba2k:focus,#pollOpt.svelte-4dba2k.svelte-4dba2k:focus,#pollOptCreate.svelte-4dba2k.svelte-4dba2k:focus{outline:none}";
	append(document_1.head, style);
}

function get_each_context(ctx, list, i) {
	const child_ctx = ctx.slice();
	child_ctx[23] = list[i][0];
	child_ctx[24] = list[i][1];
	return child_ctx;
}

// (476:0) {#if poll.opts && Object.keys(poll.opts).length > 0}
function create_if_block(ctx) {
	let div2;
	let input;
	let input_disabled_value;
	let t0;
	let t1;
	let div0;
	let each_blocks = [];
	let each_1_lookup = new Map();
	let t2;
	let t3;
	let div1;
	let mounted;
	let dispose;

	function select_block_type(ctx, dirty) {
		if (/*editMode*/ ctx[6]) return create_if_block_11;
		return create_else_block_5;
	}

	let current_block_type = select_block_type(ctx, -1);
	let if_block0 = current_block_type(ctx);
	let each_value = Object.entries(/*poll*/ ctx[3].opts);
	const get_key = ctx => /*key*/ ctx[23];

	for (let i = 0; i < each_value.length; i += 1) {
		let child_ctx = get_each_context(ctx, each_value, i);
		let key = get_key(child_ctx);
		each_1_lookup.set(key, each_blocks[i] = create_each_block(key, child_ctx));
	}

	let if_block1 = !/*editMode*/ ctx[6] && (/*voted*/ ctx[0] || /*owner*/ ctx[7]) && create_if_block_6(ctx);

	function select_block_type_1(ctx, dirty) {
		if (/*editMode*/ ctx[6]) return create_if_block_1;
		return create_else_block_1;
	}

	let current_block_type_1 = select_block_type_1(ctx, -1);
	let if_block2 = current_block_type_1(ctx);

	return {
		c() {
			div2 = element("div");
			input = element("input");
			t0 = space();
			if_block0.c();
			t1 = space();
			div0 = element("div");

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].c();
			}

			t2 = space();
			if (if_block1) if_block1.c();
			t3 = space();
			div1 = element("div");
			if_block2.c();
			attr(input, "type", "text");
			attr(input, "placeholder", "poll name");
			input.disabled = input_disabled_value = /*editMode*/ ctx[6] ? false : true;
			attr(input, "id", "pollName");
			attr(input, "class", "svelte-4dba2k");
			attr(div0, "id", "pollOpts");
			attr(div0, "class", "svelte-4dba2k");
			attr(div1, "id", "create");
			attr(div2, "id", "pollMain");
			attr(div2, "class", "svelte-4dba2k");
		},
		m(target, anchor) {
			insert(target, div2, anchor);
			append(div2, input);
			set_input_value(input, /*poll*/ ctx[3].name);
			append(div2, t0);
			if_block0.m(div2, null);
			append(div2, t1);
			append(div2, div0);

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].m(div0, null);
			}

			append(div2, t2);
			if (if_block1) if_block1.m(div2, null);
			append(div2, t3);
			append(div2, div1);
			if_block2.m(div1, null);

			if (!mounted) {
				dispose = listen(input, "input", /*input_input_handler*/ ctx[14]);
				mounted = true;
			}
		},
		p(ctx, dirty) {
			if (dirty & /*poll*/ 8 && input.value !== /*poll*/ ctx[3].name) {
				set_input_value(input, /*poll*/ ctx[3].name);
			}

			if_block0.p(ctx, dirty);

			if (dirty & /*Object, poll, vote, winningPercentage, editMode, totalVotes, delOpt, keyDownOpt*/ 2680) {
				const each_value = Object.entries(/*poll*/ ctx[3].opts);
				each_blocks = update_keyed_each(each_blocks, dirty, get_key, 1, ctx, each_value, each_1_lookup, div0, destroy_block, create_each_block, null, get_each_context);
			}

			if (!/*editMode*/ ctx[6] && (/*voted*/ ctx[0] || /*owner*/ ctx[7])) {
				if (if_block1) {
					if_block1.p(ctx, dirty);
				} else {
					if_block1 = create_if_block_6(ctx);
					if_block1.c();
					if_block1.m(div2, t3);
				}
			} else if (if_block1) {
				if_block1.d(1);
				if_block1 = null;
			}

			if_block2.p(ctx, dirty);
		},
		d(detaching) {
			if (detaching) detach(div2);
			if_block0.d();

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].d();
			}

			if (if_block1) if_block1.d();
			if_block2.d();
			mounted = false;
			dispose();
		}
	};
}

// (490:4) {:else}
function create_else_block_5(ctx) {
	let p;
	let t_value = /*poll*/ ctx[3].desc + "";
	let t;

	return {
		c() {
			p = element("p");
			t = text(t_value);
			attr(p, "id", "pollDesc");
			attr(p, "placeholder", "description");
			attr(p, "class", "svelte-4dba2k");
		},
		m(target, anchor) {
			insert(target, p, anchor);
			append(p, t);
		},
		p(ctx, dirty) {
			if (dirty & /*poll*/ 8 && t_value !== (t_value = /*poll*/ ctx[3].desc + "")) set_data(t, t_value);
		},
		d(detaching) {
			if (detaching) detach(p);
		}
	};
}

// (484:4) {#if editMode}
function create_if_block_11(ctx) {
	let p;
	let mounted;
	let dispose;

	return {
		c() {
			p = element("p");
			attr(p, "id", "pollDesc");
			attr(p, "contenteditable", "true");
			attr(p, "placeholder", "description");
			attr(p, "class", "svelte-4dba2k");
			if (/*poll*/ ctx[3].desc === void 0) add_render_callback(() => /*p_input_handler*/ ctx[15].call(p));
		},
		m(target, anchor) {
			insert(target, p, anchor);

			if (/*poll*/ ctx[3].desc !== void 0) {
				p.textContent = /*poll*/ ctx[3].desc;
			}

			if (!mounted) {
				dispose = listen(p, "input", /*p_input_handler*/ ctx[15]);
				mounted = true;
			}
		},
		p(ctx, dirty) {
			if (dirty & /*poll*/ 8 && /*poll*/ ctx[3].desc !== p.textContent) {
				p.textContent = /*poll*/ ctx[3].desc;
			}
		},
		d(detaching) {
			if (detaching) detach(p);
			mounted = false;
			dispose();
		}
	};
}

// (508:10) {#if editMode}
function create_if_block_10(ctx) {
	let div;
	let mounted;
	let dispose;

	return {
		c() {
			div = element("div");
			div.innerHTML = `<i class="fas fa-trash svelte-4dba2k"></i>`;
			attr(div, "class", "optRemove svelte-4dba2k");
		},
		m(target, anchor) {
			insert(target, div, anchor);

			if (!mounted) {
				dispose = listen(div, "click", function () {
					if (is_function(/*delOpt*/ ctx[9](/*key*/ ctx[23]))) /*delOpt*/ ctx[9](/*key*/ ctx[23]).apply(this, arguments);
				});

				mounted = true;
			}
		},
		p(new_ctx, dirty) {
			ctx = new_ctx;
		},
		d(detaching) {
			if (detaching) detach(div);
			mounted = false;
			dispose();
		}
	};
}

// (513:10) {#if !editMode && totalVotes > 0}
function create_if_block_9(ctx) {
	let span;
	let span_class_value;

	return {
		c() {
			span = element("span");

			attr(span, "class", span_class_value = "optPercentage" + (/*winningPercentage*/ ctx[5] === /*key*/ ctx[23]
			? " winningPercentage"
			: "") + " svelte-4dba2k");
		},
		m(target, anchor) {
			insert(target, span, anchor);
		},
		p(ctx, dirty) {
			if (dirty & /*winningPercentage, poll*/ 40 && span_class_value !== (span_class_value = "optPercentage" + (/*winningPercentage*/ ctx[5] === /*key*/ ctx[23]
			? " winningPercentage"
			: "") + " svelte-4dba2k")) {
				attr(span, "class", span_class_value);
			}
		},
		d(detaching) {
			if (detaching) detach(span);
		}
	};
}

// (494:6) {#each Object.entries(poll.opts) as [key, opt] (key)}
function create_each_block(key_2, ctx) {
	let div;
	let input;
	let input_class_value;
	let input_disabled_value;
	let t0;
	let t1;
	let t2;
	let div_id_value;
	let div_data_key_value;
	let mounted;
	let dispose;

	function input_input_handler_1() {
		/*input_input_handler_1*/ ctx[16].call(input, /*key*/ ctx[23]);
	}

	let if_block0 = /*editMode*/ ctx[6] && create_if_block_10(ctx);
	let if_block1 = !/*editMode*/ ctx[6] && /*totalVotes*/ ctx[4] > 0 && create_if_block_9(ctx);

	return {
		key: key_2,
		first: null,
		c() {
			div = element("div");
			input = element("input");
			t0 = space();
			if (if_block0) if_block0.c();
			t1 = space();
			if (if_block1) if_block1.c();
			t2 = space();
			attr(input, "type", "text");
			attr(input, "class", input_class_value = "optTxt " + (/*editMode*/ ctx[6] ? "" : "optSelect") + " svelte-4dba2k");
			input.disabled = input_disabled_value = /*editMode*/ ctx[6] ? false : true;
			attr(input, "maxlength", "50");
			attr(input, "placeholder", "poll option");
			attr(div, "class", "pollOpt svelte-4dba2k");
			attr(div, "id", div_id_value = "pollOpt-" + /*key*/ ctx[23]);
			attr(div, "data-key", div_data_key_value = /*key*/ ctx[23]);
			this.first = div;
		},
		m(target, anchor) {
			insert(target, div, anchor);
			append(div, input);
			set_input_value(input, /*poll*/ ctx[3].opts[/*key*/ ctx[23]]);
			append(div, t0);
			if (if_block0) if_block0.m(div, null);
			append(div, t1);
			if (if_block1) if_block1.m(div, null);
			append(div, t2);

			if (!mounted) {
				dispose = [
					listen(input, "keydown", keyDownOpt),
					listen(input, "input", input_input_handler_1),
					listen(div, "click", function () {
						if (is_function(/*vote*/ ctx[11](/*key*/ ctx[23]))) /*vote*/ ctx[11](/*key*/ ctx[23]).apply(this, arguments);
					})
				];

				mounted = true;
			}
		},
		p(new_ctx, dirty) {
			ctx = new_ctx;

			if (dirty & /*poll, Object*/ 8 && input.value !== /*poll*/ ctx[3].opts[/*key*/ ctx[23]]) {
				set_input_value(input, /*poll*/ ctx[3].opts[/*key*/ ctx[23]]);
			}

			if (/*editMode*/ ctx[6]) if_block0.p(ctx, dirty);

			if (!/*editMode*/ ctx[6] && /*totalVotes*/ ctx[4] > 0) {
				if (if_block1) {
					if_block1.p(ctx, dirty);
				} else {
					if_block1 = create_if_block_9(ctx);
					if_block1.c();
					if_block1.m(div, t2);
				}
			} else if (if_block1) {
				if_block1.d(1);
				if_block1 = null;
			}

			if (dirty & /*poll*/ 8 && div_id_value !== (div_id_value = "pollOpt-" + /*key*/ ctx[23])) {
				attr(div, "id", div_id_value);
			}

			if (dirty & /*poll*/ 8 && div_data_key_value !== (div_data_key_value = /*key*/ ctx[23])) {
				attr(div, "data-key", div_data_key_value);
			}
		},
		d(detaching) {
			if (detaching) detach(div);
			if (if_block0) if_block0.d();
			if (if_block1) if_block1.d();
			mounted = false;
			run_all(dispose);
		}
	};
}

// (520:4) {#if !editMode && (voted || owner)}
function create_if_block_6(ctx) {
	let span;
	let t0;
	let t1;
	let t2;
	let if_block1_anchor;
	let if_block0 = /*totalVotes*/ ctx[4] !== 1 && create_if_block_8(ctx);
	let if_block1 = /*voteDidntCount*/ ctx[1] && create_if_block_7(ctx);

	return {
		c() {
			span = element("span");
			t0 = text(/*totalVotes*/ ctx[4]);
			t1 = text(" vote");
			if (if_block0) if_block0.c();
			t2 = space();
			if (if_block1) if_block1.c();
			if_block1_anchor = empty();
			attr(span, "id", "voteCount");
			attr(span, "class", "svelte-4dba2k");
		},
		m(target, anchor) {
			insert(target, span, anchor);
			append(span, t0);
			append(span, t1);
			if (if_block0) if_block0.m(span, null);
			insert(target, t2, anchor);
			if (if_block1) if_block1.m(target, anchor);
			insert(target, if_block1_anchor, anchor);
		},
		p(ctx, dirty) {
			if (dirty & /*totalVotes*/ 16) set_data(t0, /*totalVotes*/ ctx[4]);

			if (/*totalVotes*/ ctx[4] !== 1) {
				if (if_block0) {
					
				} else {
					if_block0 = create_if_block_8(ctx);
					if_block0.c();
					if_block0.m(span, null);
				}
			} else if (if_block0) {
				if_block0.d(1);
				if_block0 = null;
			}

			if (/*voteDidntCount*/ ctx[1]) {
				if (if_block1) {
					
				} else {
					if_block1 = create_if_block_7(ctx);
					if_block1.c();
					if_block1.m(if_block1_anchor.parentNode, if_block1_anchor);
				}
			} else if (if_block1) {
				if_block1.d(1);
				if_block1 = null;
			}
		},
		d(detaching) {
			if (detaching) detach(span);
			if (if_block0) if_block0.d();
			if (detaching) detach(t2);
			if (if_block1) if_block1.d(detaching);
			if (detaching) detach(if_block1_anchor);
		}
	};
}

// (522:25) {#if totalVotes !== 1}
function create_if_block_8(ctx) {
	let t;

	return {
		c() {
			t = text("s");
		},
		m(target, anchor) {
			insert(target, t, anchor);
		},
		d(detaching) {
			if (detaching) detach(t);
		}
	};
}

// (524:6) {#if voteDidntCount}
function create_if_block_7(ctx) {
	let span;

	return {
		c() {
			span = element("span");
			span.textContent = "waiting for the vote to be counted...";
			attr(span, "id", "deliveredVote");
			attr(span, "class", "svelte-4dba2k");
		},
		m(target, anchor) {
			insert(target, span, anchor);
		},
		d(detaching) {
			if (detaching) detach(span);
		}
	};
}

// (540:6) {:else}
function create_else_block_1(ctx) {
	let div;
	let i;
	let div_data_clipboard_text_value;
	let t;
	let if_block_anchor;
	let mounted;
	let dispose;

	function select_block_type_3(ctx, dirty) {
		if (/*owner*/ ctx[7]) return create_if_block_3;
		return create_else_block_3;
	}

	let current_block_type = select_block_type_3(ctx, -1);
	let if_block = current_block_type(ctx);

	return {
		c() {
			div = element("div");
			i = element("i");
			t = space();
			if_block.c();
			if_block_anchor = empty();
			attr(i, "class", "fas fa-share-alt svelte-4dba2k");
			attr(div, "id", "pollOptCreate");
			attr(div, "class", "copy svelte-4dba2k");
			attr(div, "data-clipboard-text", div_data_clipboard_text_value = location.href);
		},
		m(target, anchor) {
			insert(target, div, anchor);
			append(div, i);
			insert(target, t, anchor);
			if_block.m(target, anchor);
			insert(target, if_block_anchor, anchor);

			if (!mounted) {
				dispose = listen(div, "click", copy);
				mounted = true;
			}
		},
		p(ctx, dirty) {
			if_block.p(ctx, dirty);
		},
		d(detaching) {
			if (detaching) detach(div);
			if (detaching) detach(t);
			if_block.d(detaching);
			if (detaching) detach(if_block_anchor);
			mounted = false;
			dispose();
		}
	};
}

// (529:6) {#if editMode}
function create_if_block_1(ctx) {
	let div0;
	let t;
	let div1;
	let mounted;
	let dispose;

	function select_block_type_2(ctx, dirty) {
		if (!/*clickedMainButton*/ ctx[2]) return create_if_block_2;
		return create_else_block;
	}

	let current_block_type = select_block_type_2(ctx, -1);
	let if_block = current_block_type(ctx);

	return {
		c() {
			div0 = element("div");
			div0.innerHTML = `<i class="fas fa-plus svelte-4dba2k"></i>`;
			t = space();
			div1 = element("div");
			if_block.c();
			attr(div0, "id", "pollOptCreate");
			attr(div0, "class", "svelte-4dba2k");
			attr(div1, "id", "pollSubmit");
			attr(div1, "class", "svelte-4dba2k");
		},
		m(target, anchor) {
			insert(target, div0, anchor);
			insert(target, t, anchor);
			insert(target, div1, anchor);
			if_block.m(div1, null);

			if (!mounted) {
				dispose = [
					listen(div0, "click", /*newOpt*/ ctx[8]),
					listen(div1, "click", /*submit*/ ctx[10])
				];

				mounted = true;
			}
		},
		p(ctx, dirty) {
			if (current_block_type !== (current_block_type = select_block_type_2(ctx, dirty))) {
				if_block.d(1);
				if_block = current_block_type(ctx);

				if (if_block) {
					if_block.c();
					if_block.m(div1, null);
				}
			}
		},
		d(detaching) {
			if (detaching) detach(div0);
			if (detaching) detach(t);
			if (detaching) detach(div1);
			if_block.d();
			mounted = false;
			run_all(dispose);
		}
	};
}

// (556:8) {:else}
function create_else_block_3(ctx) {
	let div;
	let mounted;
	let dispose;

	function select_block_type_5(ctx, dirty) {
		if (!/*clickedMainButton*/ ctx[2]) return create_if_block_5;
		return create_else_block_4;
	}

	let current_block_type = select_block_type_5(ctx, -1);
	let if_block = current_block_type(ctx);

	return {
		c() {
			div = element("div");
			if_block.c();
			attr(div, "id", "pollSubmit");
			attr(div, "class", "svelte-4dba2k");
		},
		m(target, anchor) {
			insert(target, div, anchor);
			if_block.m(div, null);

			if (!mounted) {
				dispose = listen(div, "click", /*clonePoll*/ ctx[13]);
				mounted = true;
			}
		},
		p(ctx, dirty) {
			if (current_block_type !== (current_block_type = select_block_type_5(ctx, dirty))) {
				if_block.d(1);
				if_block = current_block_type(ctx);

				if (if_block) {
					if_block.c();
					if_block.m(div, null);
				}
			}
		},
		d(detaching) {
			if (detaching) detach(div);
			if_block.d();
			mounted = false;
			dispose();
		}
	};
}

// (548:8) {#if owner}
function create_if_block_3(ctx) {
	let div;
	let mounted;
	let dispose;

	function select_block_type_4(ctx, dirty) {
		if (!/*clickedMainButton*/ ctx[2]) return create_if_block_4;
		return create_else_block_2;
	}

	let current_block_type = select_block_type_4(ctx, -1);
	let if_block = current_block_type(ctx);

	return {
		c() {
			div = element("div");
			if_block.c();
			attr(div, "id", "pollSubmit");
			attr(div, "class", "svelte-4dba2k");
		},
		m(target, anchor) {
			insert(target, div, anchor);
			if_block.m(div, null);

			if (!mounted) {
				dispose = listen(div, "click", /*deletePoll*/ ctx[12]);
				mounted = true;
			}
		},
		p(ctx, dirty) {
			if (current_block_type !== (current_block_type = select_block_type_4(ctx, dirty))) {
				if_block.d(1);
				if_block = current_block_type(ctx);

				if (if_block) {
					if_block.c();
					if_block.m(div, null);
				}
			}
		},
		d(detaching) {
			if (detaching) detach(div);
			if_block.d();
			mounted = false;
			dispose();
		}
	};
}

// (560:12) {:else}
function create_else_block_4(ctx) {
	let i;

	return {
		c() {
			i = element("i");
			attr(i, "class", "fas fa-sync-alt loading svelte-4dba2k");
		},
		m(target, anchor) {
			insert(target, i, anchor);
		},
		d(detaching) {
			if (detaching) detach(i);
		}
	};
}

// (558:12) {#if !clickedMainButton}
function create_if_block_5(ctx) {
	let t;

	return {
		c() {
			t = text("clone");
		},
		m(target, anchor) {
			insert(target, t, anchor);
		},
		d(detaching) {
			if (detaching) detach(t);
		}
	};
}

// (552:12) {:else}
function create_else_block_2(ctx) {
	let i;

	return {
		c() {
			i = element("i");
			attr(i, "class", "fas fa-sync-alt loading svelte-4dba2k");
		},
		m(target, anchor) {
			insert(target, i, anchor);
		},
		d(detaching) {
			if (detaching) detach(i);
		}
	};
}

// (550:12) {#if !clickedMainButton}
function create_if_block_4(ctx) {
	let t;

	return {
		c() {
			t = text("delete");
		},
		m(target, anchor) {
			insert(target, t, anchor);
		},
		d(detaching) {
			if (detaching) detach(t);
		}
	};
}

// (536:10) {:else}
function create_else_block(ctx) {
	let i;

	return {
		c() {
			i = element("i");
			attr(i, "class", "fas fa-sync-alt loading svelte-4dba2k");
		},
		m(target, anchor) {
			insert(target, i, anchor);
		},
		d(detaching) {
			if (detaching) detach(i);
		}
	};
}

// (534:10) {#if !clickedMainButton}
function create_if_block_2(ctx) {
	let t;

	return {
		c() {
			t = text("submit");
		},
		m(target, anchor) {
			insert(target, t, anchor);
		},
		d(detaching) {
			if (detaching) detach(t);
		}
	};
}

function create_fragment(ctx) {
	let show_if = /*poll*/ ctx[3].opts && Object.keys(/*poll*/ ctx[3].opts).length > 0;
	let if_block_anchor;
	let if_block = show_if && create_if_block(ctx);

	return {
		c() {
			if (if_block) if_block.c();
			if_block_anchor = empty();
		},
		m(target, anchor) {
			if (if_block) if_block.m(target, anchor);
			insert(target, if_block_anchor, anchor);
		},
		p(ctx, [dirty]) {
			if (dirty & /*poll*/ 8) show_if = /*poll*/ ctx[3].opts && Object.keys(/*poll*/ ctx[3].opts).length > 0;

			if (show_if) {
				if (if_block) {
					if_block.p(ctx, dirty);
				} else {
					if_block = create_if_block(ctx);
					if_block.c();
					if_block.m(if_block_anchor.parentNode, if_block_anchor);
				}
			} else if (if_block) {
				if_block.d(1);
				if_block = null;
			}
		},
		i: noop,
		o: noop,
		d(detaching) {
			if (if_block) if_block.d(detaching);
			if (detaching) detach(if_block_anchor);
		}
	};
}

function genKey() {
	var chars = ("abcdefghijklmnopqrstuvwxyz").split("");
	var key = "";

	for (var i = 0; i < 5; i++) {
		key += chars[Math.floor(Math.random() * chars.length)];
	}

	return key;
}

function keyDownOpt(e) {
	if (e.target.textContent.length > 30 && !e.ctrlKey && e.which !== 8) e.preventDefault();
}

function copy() {
	alert("Copied poll link");
}

function instance($$self, $$props, $$invalidate) {
	var clipboard = new ClipboardJS(".copy");
	document.title = "Gupoll";

	var editMode = location.hash.length > 1 && !location.hash.startsWith("#clone/")
	? false
	: true;

	var hash = location.hash.slice(1) || "";
	var owner = hash.length > 1 && !hash.startsWith("#clone/") && localStorage[hash] !== undefined;
	var voted = false;
	var voteDidntCount = false;
	var globalUser = {};
	var clickedMainButton = false;
	var poll = {};

	if (editMode) poll = {
		name: "",
		desc: "",
		opts: { abcde: "", abcdf: "" }
	};

	var results = {};
	var totalVotes = 0;
	var acceptedVotes = [];
	if (localStorage["gun/"]) delete localStorage["gun/"];

	// When it loads...
	(async function () {
		if (!editMode) {
			let user = gun.user((await gun.get("gupoll#<?604800").get(location.hash.slice(1)).promOnce()).data);

			if (localStorage[hash]) {
				user = gun.user();
				user.auth(JSON.parse(localStorage[hash]));
			}

			globalUser = user;
			$$invalidate(3, poll.name = (await user.get("name").promOnce()).data, poll);
			$$invalidate(3, poll.desc = (await user.get("desc").promOnce()).data, poll);
			$$invalidate(3, poll.opts = {}, poll);

			user.get("opts").map().once(function (data, key) {
				$$invalidate(3, poll.opts[key] = data, poll);
			});

			for (var i in poll.opts) {
				$$invalidate(18, results[key] = 0, results);
			}

			user.get("votes").map().on(function (data, key) {
				$$invalidate(18, results[key] = data, results);
				console.log(results);
				$$invalidate(4, totalVotes = Object.values(results).reduce((acc, prev) => acc + prev) || 0);

				if (owner) setTimeout(
					() => {
						$$invalidate(0, voted = true);
						showVotes();
					},
					700
				);

				$$invalidate(1, voteDidntCount = false);

				if (!owner && voted) setTimeout(
					() => {
						showVotes();
					},
					500
				);
			});

			user.get("acceptedVotes").map().once(function (data, key) {
				if (data === true) acceptedVotes.push(key);
			});

			if (owner) {
				gun.get(`gunote@${hash}/votes#<?604800`).map().on(async function (data, key) {
					if (acceptedVotes.includes(key)) return;
					user.get("votes").get(JSON.parse(data).opt).put(results[JSON.parse(data).opt] + 1);
					$$invalidate(18, results[JSON.parse(data).opt] += 1, results);
					await user.get("acceptedVotes").get(key).promPut(true);
				});
			}
		} else if (location.hash.startsWith("#clone/")) {
			(async () => {
				$$invalidate(3, poll = {});
				var pollHash = location.hash.slice(7);
				var user = gun.user((await gun.get("gupoll#<?604800").get(pollHash).promOnce()).data);

				setTimeout(
					async () => {
						$$invalidate(3, poll.name = (await user.get("name").promOnce()).data, poll);
						$$invalidate(3, poll.desc = (await user.get("desc").promOnce()).data, poll);
						$$invalidate(3, poll.opts = {}, poll);

						user.get("opts").map().once(function (data, key) {
							$$invalidate(3, poll.opts[key] = data, poll);
						});

						location.hash = "";
					},
					1000
				);
			})();
		}
	})();

	function newOpt(e) {
		var key = genKey();
		$$invalidate(3, poll.opts[key] = "", poll);
	}

	function delOpt(key) {
		delete poll.opts[key];
		$$invalidate(3, poll);
		if (Object.values(poll.opts).length < 1) newOpt();
	} //document.querySelector("html").style.setProperty("--theme-color", "green");

	async function submit() {
		if (clickedMainButton) return;

		if (poll.name.length < 1) {
			document.querySelector("#pollName").focus();
			alert("Poll name missing.");
			return;
		}

		if (poll.desc.length < 1) {
			document.querySelector("#pollDesc").focus();
			alert("Poll description missing.");
			return;
		}

		$$invalidate(2, clickedMainButton = true);
		var pollCopy = poll;
		pollCopy.votes = {};

		var a = setTimeout(
			() => {
				alert("Something went wrong. Try refreshing the page and submitting again.");
				$$invalidate(2, clickedMainButton = false);
			},
			8000
		);

		for (var i in pollCopy.opts) {
			pollCopy.votes[i] = 0;
		}

		const pair = await SEA.pair();
		const user = gun.user();
		user.auth(pair);
		await user.promPut(pollCopy);
		const hash = await SEA.work(pair.pub, null, null, { name: "SHA-256" });
		await gun.get(`gupoll#<?604800`).get(hash).promPut(pair.pub);
		localStorage[hash] = JSON.stringify(pair);
		location.hash = hash;
		clearTimeout(a);

		setTimeout(
			() => {
				location.reload(true);
			},
			500
		);
	}

	async function vote(key) {
		if (editMode) return;
		if (voted) return;
		var saveVotes = totalVotes;
		$$invalidate(1, voteDidntCount = true);

		setTimeout(
			() => {
				try {
					document.querySelector("#deliveredVote").textContent = "poll owner is offline";
					if (!voteDidntCount) return;
					$$invalidate(1, voteDidntCount = false);

					gun.get(`gunote@${hash}/votes#<?604800`).map().once(async function (data, key) {
						if (acceptedVotes.includes(key)) return;
						$$invalidate(18, results[JSON.parse(data).opt] += 1, results);
						acceptedVotes.push(key);
						$$invalidate(4, totalVotes = Object.values(results).reduce((acc, prev) => acc + prev) || 0);
						showVotes();
					});
				} catch(e) {
					
				}
			},
			5000
		);

		var vote = JSON.stringify({
			opt: key,
			numb: Math.floor(Math.random() * 99999)
		});

		var voteHash = await SEA.work(vote, null, null, { name: "SHA-256" });
		await gun.get(`gunote@${hash}/votes#<?604800`).get(voteHash).promPut(vote);
		$$invalidate(0, voted = true);
		localStorage["voted"] = (localStorage["voted"] || "") + "," + hash;
		document.activeElement.blur();
		showVotes();
	}

	function showVotes() {
		for (var i in results) {
			var totalVotes = Object.values(results).reduce((acc, pre) => acc + pre);
			var max = Math.max(...Object.values(results));
			var elem = document.querySelector(`[data-key=${i}]`);
			if (elem !== null) var perc = results[i] / totalVotes * 100 || (totalVotes > 0 ? 0 : 100);
			if (elem !== null) elem.style.width = perc + "%";
			if (elem.querySelector(".optPercentage") !== null) elem.querySelector(".optPercentage").textContent = Math.round(perc) + "%";
		}
	}

	async function deletePoll() {
		if (clickedMainButton) return;
		$$invalidate(2, clickedMainButton = true);
		console.log(globalUser);
		await globalUser.get("opts").promPut(null);
		await globalUser.get("votes").promPut(null);
		await globalUser.get("name").promPut(null);
		delete localStorage[globalUser.is.pub];
		await globalUser.delete();
		location.hash = "";

		setTimeout(
			() => {
				location.reload(true);
			},
			500
		);
	}

	function clonePoll() {
		if (clickedMainButton) return;
		$$invalidate(2, clickedMainButton = true);
		location.hash = `clone/${hash}`;
		location.reload(true);
	}

	setTimeout(
		() => {
			if (!owner && !editMode && !voted && localStorage["voted"] && localStorage["voted"].includes(hash)) {
				$$invalidate(0, voted = true);
				showVotes();
			}
		},
		1000
	);

	function input_input_handler() {
		poll.name = this.value;
		$$invalidate(3, poll);
	}

	function p_input_handler() {
		poll.desc = this.textContent;
		$$invalidate(3, poll);
	}

	function input_input_handler_1(key) {
		poll.opts[key] = this.value;
		$$invalidate(3, poll);
	}

	let winningPercentage;

	$$self.$$.update = () => {
		if ($$self.$$.dirty & /*results*/ 262144) {
			$: $$invalidate(5, winningPercentage = Object.keys(results).find(a => results[a] === Math.max(...Object.values(results))));
		}
	};

	return [
		voted,
		voteDidntCount,
		clickedMainButton,
		poll,
		totalVotes,
		winningPercentage,
		editMode,
		owner,
		newOpt,
		delOpt,
		submit,
		vote,
		deletePoll,
		clonePoll,
		input_input_handler,
		p_input_handler,
		input_input_handler_1
	];
}

class App extends SvelteComponent {
	constructor(options) {
		super();
		if (!document_1.getElementById("svelte-4dba2k-style")) add_css();
		init(this, options, instance, create_fragment, safe_not_equal, {});
	}
}

export default App;